const RAZORPAY_SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js'
const RAZORPAY_LOAD_TIMEOUT_MS = 10000

let razorpayScriptPromise = null

function getExistingRazorpayScript() {
  return document.querySelector(`script[src="${RAZORPAY_SCRIPT_SRC}"]`)
}

function waitForExistingScript(existingScript) {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay)
      return
    }

    const cleanup = () => {
      existingScript.removeEventListener('load', handleLoad)
      existingScript.removeEventListener('error', handleError)
      clearTimeout(timeoutId)
    }

    const handleLoad = () => {
      cleanup()
      if (window.Razorpay) {
        resolve(window.Razorpay)
        return
      }
      reject(new Error('Razorpay loaded without exposing window.Razorpay'))
    }

    const handleError = () => {
      cleanup()
      reject(new Error('Failed to load Razorpay checkout.js'))
    }

    const timeoutId = window.setTimeout(() => {
      cleanup()
      reject(new Error('Timed out while loading Razorpay checkout.js'))
    }, RAZORPAY_LOAD_TIMEOUT_MS)

    existingScript.addEventListener('load', handleLoad)
    existingScript.addEventListener('error', handleError)
  })
}

export function ensureRazorpayLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(new Error('Razorpay can only load in the browser'))
  }

  if (window.Razorpay) {
    return Promise.resolve(window.Razorpay)
  }

  if (razorpayScriptPromise) {
    return razorpayScriptPromise
  }

  const existingScript = getExistingRazorpayScript()
  if (existingScript) {
    razorpayScriptPromise = waitForExistingScript(existingScript).finally(() => {
      razorpayScriptPromise = null
    })
    return razorpayScriptPromise
  }

  razorpayScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const cleanup = () => {
      script.removeEventListener('load', handleLoad)
      script.removeEventListener('error', handleError)
      clearTimeout(timeoutId)
    }

    const handleLoad = () => {
      cleanup()
      if (window.Razorpay) {
        resolve(window.Razorpay)
        return
      }
      reject(new Error('Razorpay loaded without exposing window.Razorpay'))
    }

    const handleError = () => {
      cleanup()
      reject(new Error('Failed to load Razorpay checkout.js'))
    }

    const timeoutId = window.setTimeout(() => {
      cleanup()
      reject(new Error('Timed out while loading Razorpay checkout.js'))
    }, RAZORPAY_LOAD_TIMEOUT_MS)

    script.src = RAZORPAY_SCRIPT_SRC
    script.async = true
    script.defer = true
    script.addEventListener('load', handleLoad)
    script.addEventListener('error', handleError)
    document.head.appendChild(script)
  }).finally(() => {
    razorpayScriptPromise = null
  })

  return razorpayScriptPromise
}
